import React from 'react';
import { createStyledComponent, resolveCSSValue, splitStyleProps } from './style-props';

export const Box = createStyledComponent('div');
export const Flex = createStyledComponent('div', { isFlex: true, defaultStyle: { display: 'flex' } });

export function Stack({ direction = 'column', spacing, style, children, ...props }) {
  const flexDirection = direction === 'row' ? 'row' : 'column';
  const { style: propStyle, rest } = splitStyleProps(props, { isFlex: true });
  return (
    <div
      style={{
        display: 'flex',
        flexDirection,
        gap: resolveCSSValue(spacing),
        ...propStyle,
        ...style
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export const HStack = (props) => <Stack direction="row" {...props} />;
export const VStack = (props) => <Stack direction="column" {...props} />;
export const Center = createStyledComponent('div', {
  defaultStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
});
export const SimpleGrid = createStyledComponent('div', { defaultStyle: { display: 'grid' } });
export const Grid = SimpleGrid;
export const GridItem = createStyledComponent('div');
export const Circle = createStyledComponent('div', { defaultStyle: { borderRadius: '9999px' } });

export function Text({ as = 'p', className, style, children, ...props }) {
  const Tag = as === 'b' ? 'strong' : as;
  const { style: propStyle, rest } = splitStyleProps(props);
  return (
    <Tag className={className} style={propStyle} {...rest}>
      {children}
    </Tag>
  );
}

export const Heading = ({ as = 'h2', ...props }) => <Text as={as} {...props} />;
export const Divider = (props) => <Box as="hr" border="none" borderTop="1px solid #e2e8f0" {...props} />;
export const Image = (props) => <Box as="img" {...props} />;
export const Link = (props) => <Box as="a" {...props} />;
export const List = (props) => <Box as="ul" {...props} />;
export const OrderedList = (props) => <Box as="ol" {...props} />;
export const UnorderedList = List;
export const ListItem = (props) => <Box as="li" {...props} />;
export const ListIcon = (props) => <Box as="span" display="inline-flex" mr={2} {...props} />;

export function Icon({ as: Component, children, ...props }) {
  if (Component) return <Component {...props} />;
  return <span {...props}>{children}</span>;
}

export function Spinner(props) {
  return (
    <Box
      as="span"
      display="inline-block"
      w={4}
      h={4}
      border="2px solid currentColor"
      borderTopColor="transparent"
      borderRadius="full"
      animation="spin 0.8s linear infinite"
      {...props}
    />
  );
}

export function Skeleton(props) {
  return <Box bg="#ececf0" borderRadius="md" animation="pulse 2s infinite" {...props} />;
}
